import React                   from 'react'
import i18n from '../../../i18n';

export default (props) => {
  return (
    <div className="support-container small-container" id="terms-container">
      <div className="row no-gutters">
        <div className="col-sm-9 title padl-0">{i18n.t("terms.title")}</div>
        <div className="col-sm-3 text-right">
        </div>
        <div className="col-sm-12 content-body terms-of-use">
          <p>
          株式会社マネーフォワード（以下「当社」といいます。）が提供する「マネーフォワード クラウド」を利用し、取得する契約者に関する情報を利用する場合（以下「本サービス」といいます。）には、「マネーフォワード クラウド利用規約」（以下「原利用規約」といいます。）に加えて、この特約（以下「本特約」といいます。）が適用されます。本特約については、契約者が本サービスを利用した時点で同意されたものとさせていただきますので、ご利用の前に必ずお読みください。
            <br/>なお、本特約の中で使用される用語については、本特約中に別段の定めのある場合を除き、原利用規約の中で使用される定義を適用するものとします。
          </p>

          <br/>
          <h5>第1条（定義）</h5>
          <p>
            本特約において「アグリゲーション機能」とは、「契約者が当社ウェブサイト等を経由して各コンテンツサイトにアクセスし、又は当社がＡＰＩトークンを用いて情報提供元のシステムにアクセスし、もって契約者の口座情報を取得することができるサービス」をいいます。
          </p>

          <br/>
          <h5>第２条（適用除外等）</h5>
          <p>
            1.
            <br/>本特約に基づき提供される本サービスは、原利用規約第３条第１項(18)記載のサービスとし、その詳細は、アグリゲーション機能を利用して契約者が利用しているコンテンツサイト又は情報提供元に保存されている口座情報を自動取得し、取得した情報を情報提供先に提供するものとします。
            <br/>2.
            <br/>原利用規約第５条第３項にかかわらず、原利用規約及び本特約に基づく本サービス利用契約は、契約者が本サービスを利用可能になった時に、契約者と当社の間に成立するものとします。
            <br/>3.
            <br/>原利用規約第３条第１項(1)乃至(17)、第11条、第12条、第15条、第21条第2項、第25条第2項、第3項、第9項及び第11項は、適用しないものとします。
            <br/>4.
            <br/>原利用規約第８条にかかわらず、本サービスは、単一の利用プランによるものとします。利用プランの詳細は当社ウェブサイト等をご確認下さい。ただし、当社は当該利用プランの内容を変更する場合があります。当社は、変更の内容、変更に伴う措置等を、当社ウェブサイト等への掲載その他当社が適当と判断する方法により契約者に通知します。
            <br/>5.
            <br/>原利用規約第９条第１項にかかわらず、契約者は当社又は別途当社が指定する者に対し、本サービスの対価として当社が別途定める金額を当社が別途定める方法に従い支払うものとします。利用料金の詳細は当社ウェブサイト等をご確認下さい。
          </p>

          <br/>
          <h5>第３条（保証の否認及び免責）</h5>
          <p>当社は、情報提供先の行った行為につき、契約者に対し一切の責任を負いません。</p>

          <br/>
          <h5>第4条（準拠法及び合意管轄）</h5>
          <p>本特約の準拠法は日本法とし、本特約に起因し又は関連する一切の紛争については、東京地方裁判所を第一審の専属的合意管轄裁判所とします。</p>
          <p></p>
          <p>2019年8月1日 制定</p>
          <p>2021年11月25日 改定</p>
          <p>2022年12月21日 改定</p>
          <p>2024年8月29日 改定</p>
        </div>
      </div>
    </div>
  )
}
